export default [{
  label: 'Exclude Archived',
  status: 'active'
}, {
  label: 'Include Archived',
  status: 'all'
}, {
  label: 'Only Archived',
  status: 'archived'
}];